import { render, staticRenderFns } from "./TableStyleComponentDetail.vue?vue&type=template&id=641c39c6&scoped=true"
import script from "./TableStyleComponentDetail.vue?vue&type=script&lang=js"
export * from "./TableStyleComponentDetail.vue?vue&type=script&lang=js"
import style0 from "./TableStyleComponentDetail.vue?vue&type=style&index=0&id=641c39c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641c39c6",
  null
  
)

export default component.exports